// extracted by mini-css-extract-plugin
export default {"hsStarCompleted":"StepWizardFinish_hsStarCompleted__76n0P","hsStarCompletedCol":"StepWizardFinish_hsStarCompletedCol__rRBwO"};